<template>
  <div class="cart">
    <b-button
      class="shadow"
      variant="info"
      size="lg"
      v-if="items > 0"
      v-b-modal.cart-finalize
    >
      <b-icon-cart-check-fill></b-icon-cart-check-fill> {{ $t("shop.cart") }}
      <b-badge variant="light">{{ items }}</b-badge>
    </b-button>
    <b-modal id="cart-finalize" hide-header hide-footer size="xl">
      <cart-finalize></cart-finalize>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CartFinalize from "@/components/CartFinalize";

export default {
  name: "Cart",
  components: { CartFinalize },
  computed: {
    ...mapGetters({ items: "cart/cartTotalCount" }),
  },
  created() {
    this.$store.subscribeAction((action) => {
      if (action.type === "cart/addProductToCart") {
        const messageNode = this.$createElement("h5", {
          domProps: {
            innerHTML: `${this.$t("shop.added")} "${action.payload.title}"`,
          },
          class: "font-weight-normal",
        });
        this.$bvModal
          .msgBoxConfirm([messageNode], {
            okTitle: this.$t("shop.finalize"),
            okVariant: "success",
            cancelTitle: this.$t("shop.continue"),
            cancelVariant: "info",
            centered: true,
          })
          .then((val) => {
            if (val) {
              this.$bvModal.show("cart-finalize");
            }
          })
          .catch(() => {});
      }
    });
  },
};
</script>

<style scoped>
.cart {
  position: fixed;
  bottom: 2em;
  right: 2em;
  z-index: 1020;
  padding: 1rem;
}
</style>
